export default {"src":"/_next/static/media/case_icon.83e9b86b.svg","height":32,"width":35,"blurWidth":0,"blurHeight":0};